import React, { useEffect, useMemo, useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from "react-redux";
import { setIbtResultListLoading, setIbtSidebarLoading, setSelectedIbtData } from "@modules/ibt";
import { useSelector } from "react-redux";

const IBTSidebar = () => {

    const dispatch = useDispatch()
    const [sidebarText, setSidebarText] = useState('')
    const [sidebarList, setSidebarList] = useState([])

    const ibtSidebarLoading = useSelector((state) => state.ibt.ibtSidebarLoading)

    useEffect(() => {
        dispatch(setIbtSidebarLoading(true))

        try {
            console.log('get sidebar list data')
            // const response = await api.get('/ibt/sidebar-list')
        } catch (error) {
            console.log('error: ', error)
        } finally {
            setTimeout(() => {
                dispatch(setIbtSidebarLoading(false))
            }, 1500)
        }
    }, [])

    useEffect(() => {
        console.log('sidebarText: ', sidebarText)

    }, [sidebarText])

    // sidebar search list data
    const filteredSidebarList = useMemo(() => {
        if(!sidebarText.trim()) return sidebarList

        return sidebarList.filter((item) => item.title.includes(sidebarText))
    }, [sidebarText, sidebarList])

    const handleSidebarItemClick = (_, i) => {
        console.log('item: ', _, i)
        dispatch(setIbtResultListLoading(true)) // result list loading
        dispatch(setSelectedIbtData({
            'quizid': 300
        }))
    }

    const renderSidebarData = () => {
        return Array.from({ length: 20 }).map((_, i) => (
            <Box key={i} className='pt-3 pb-3 pl-3 pr-3 border-bottom-1 ibt-sidebar-item' onClick={() => handleSidebarItemClick(_, i)}>
                <Box className='fw-bold'>사전모의 TEST - 한자</Box>
                <Box>2025.01.22 - 2025.03.22</Box>
            </Box>
        ));
    }

    return (
        <Box id="ibt-sidebar" className='ibt-sidebar fs-0'>
            <TextField 
                className='txt-input-padding'
                // label="검색어를 입력하세요."
                variant="outlined"
                size='small' fullWidth
                placeholder="검색어를 입력하세요."
                onChange={(e) => setSidebarText(e.target.value)}
                value={sidebarText}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                  }}
            />
            { ibtSidebarLoading ? <Box className='sidebar-loading-wrapper'><Box className='ibt-loading' /></Box> : renderSidebarData() }
        </Box>
    )
}

export default IBTSidebar;